import { Util } from 'wize-admin'
import {http} from '@/http'

export default {
  login(payload) {
    const formData = Util.getFormData(payload);
    return http.post('/api/v1/auth', formData, {headers: { "Content-Type": "multipart/form-data" },})
  },
  isValidToken() {
    return http.get('/api/v1/auth/token')
  },
  recoverPassword(data) {
    return http.put('/api/v1/auth/recover-password', data)
  },
  resetPassword(data) {
    return http.post('/api/v1/auth/password', data)
  },
  refreshToken(payload) {
    return http.post('api/v1/auth/refresh-token', payload, {removeAuth: true})
  },
  getUserInfo() {
    return http.get("/api/v1/auth/me");
  },
  updatePassword(data) {
    return http.put(`/api/v1/auth/password`, data)
  }
}
